import ReactDOM from 'react-dom'
import { store } from './core/store/store'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'

import '@fortawesome/fontawesome-free/css/all.css'
import './assets/styles/app.scss'

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root'),
)
